<div class="curr-question-tags-selector" currClickOutsideTags (clickOutside)="closePanel()">
  <mat-form-field appearance="outline" class="tags-form-field" floatLabel="auto">
    <mat-label>Question Tag(s)</mat-label>

    <mat-chip-list #chipList class="tags-chip-list" aria-label="Selected tags" [multiple]="true">
      <mat-chip *ngFor="let tag of selectedTags; trackBy: trackByValue" [selectable]="false" [removable]="true" class="tag-chip" (removed)="toggleTagSelection(tag)">
        {{ tag?.tag }}
        <mat-icon [svgIcon]="'close-circle'" matChipRemove></mat-icon>
      </mat-chip>

      <input
        #tagInput
        matInput
        class="tag-input"
        [formControl]="inputCtrl"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="false"
        (keydown.backspace)="onBackspace($event)"
        (focus)="openPanel()"
        autocomplete="off"
      />
    </mat-chip-list>

    <button matSuffix mat-icon-button class="toggle-btn" (click)="togglePanel($event)" type="button">
      <mat-icon>{{ isPanelOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
  </mat-form-field>

  <div *ngIf="isPanelOpen" #panelEl class="tags-dropdown-panel" role="listbox">
    <ng-container *ngIf="visibleOptions.length; else noResultsTpl">
      <div class="option-row" role="option" *ngFor="let option of visibleOptions; trackBy: trackByValue" (click)="onOptionClicked(option)">
        <span class="option-text">{{ option?.tag }}</span>
        <mat-icon *ngIf="isSelected(option)" [svgIcon]="'check'" class="check-icon"></mat-icon>
        <div class="item-line"></div>
      </div>
      <div class="option-row loading" *ngIf="loading">
        <curr-loader [diameter]="40"></curr-loader>
      </div>
    </ng-container>
    <ng-template #noResultsTpl>
      <div class="option-row loading" *ngIf="loading">
        <curr-loader [diameter]="40"></curr-loader>
      </div>
      <div class="option-row add-new-row" *ngIf="!loading" [@fadeInOut]>
        <div class="no-match-text" *ngIf="isEditMode">No matching tag found. Add a new one?</div>
        <div class="no-match-text" *ngIf="!isEditMode">No matching tag found.</div>
        <curr-button
          *ngIf="isEditMode"
          class="add-test-btn"
          icon="icon-plus"
          size="big"
          variant="text"
          (click)="$event.preventDefault(); $event.stopPropagation(); addNewFromInput()">
          Add New
        </curr-button>
      </div>
    </ng-template>
  </div>
</div>
